import styled from 'styled-components'
import { stoColor, stoRadius, stoShadow, stoSpace, stoType } from 'constants/stoTheme'

const DURATION = '300ms'
const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)'

/** Collapsed, it lifts under the pointer as a collapsed section does. */
export const Root = styled.div<{ $open: boolean }>`
  background: ${stoColor.surface};
  border: 1px solid ${stoColor.borderSubtle};
  border-radius: ${stoRadius.lg};
  box-shadow: ${stoShadow.xs};

  /* Pointer devices only: on touch a tap leaves :hover stuck after closing it. */
  ${({ $open }) =>
    !$open &&
    `
    @media (hover: hover) {
      &:hover {
        box-shadow: ${stoShadow.hover};
      }
    }
  `}
`

export const Header = styled.button<{ $divided: boolean }>`
  position: relative;
  ${stoType.bodyMdCallout};
  font-family: inherit;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${stoSpace[4]};
  width: 100%;
  padding: ${stoSpace[5]};
  border: none;
  background: none;
  color: ${stoColor.textPrimary};
  text-align: left;
  cursor: pointer;

  ${({ $divided }) =>
    $divided &&
    `
    padding-bottom: ${stoSpace[4]};

    &::after {
      content: '';
      position: absolute;
      right: ${stoSpace[5]};
      bottom: 0;
      left: ${stoSpace[5]};
      border-bottom: 1px solid ${stoColor.borderSubtle};
    }
  `}
`

export const Chevron = styled.span<{ $open: boolean }>`
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  transform: rotate(${({ $open }) => ($open ? '180deg' : '0deg')});
  transition: transform ${DURATION} ${EASING};

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

/** Animates height without measuring: grid rows transition between 0fr and 1fr. */
export const Body = styled.div<{ $open: boolean }>`
  display: grid;
  grid-template-rows: ${({ $open }) => ($open ? '1fr' : '0fr')};
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  transition:
    grid-template-rows ${DURATION} ${EASING},
    opacity ${DURATION} ${EASING};

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const BodyClip = styled.div`
  min-height: 0;
  overflow: hidden;
`

export const BodyInner = styled.div<{ $divided: boolean }>`
  ${stoType.bodyMdRegular};
  padding: ${({ $divided }) => ($divided ? stoSpace[6] : '0')} ${stoSpace[5]} ${stoSpace[5]};
  color: ${stoColor.textSecondary};
`
